import { Row, Col } from "antd";
import { CSSProperties, ReactNode, Children, isValidElement } from "react";

interface FormFieldGridProps {
  children: ReactNode;
  columns?: 1 | 2 | 3 | 4;
  gutter?: [number, number];
  responsive?: boolean;
}

const gridStyles = {
  container: {
    width: "100%",
  } as CSSProperties,
};

const getResponsiveSpan = (columns: number) => {
  switch (columns) {
    case 1:
      return { xs: 24, sm: 24, md: 24, lg: 24 };
    case 2:
      return { xs: 24, sm: 24, md: 12, lg: 12 };
    case 3:
      return { xs: 24, sm: 12, md: 8, lg: 8 };
    case 4:
      return { xs: 24, sm: 12, md: 6, lg: 6 };
    default:
      return { xs: 24, sm: 24, md: 12, lg: 12 };
  }
};

export const FormFieldGrid: React.FC<FormFieldGridProps> = ({
  children,
  columns = 2,
  gutter = [24, 16],
  responsive = true,
}) => {
  const childArray = Children.toArray(children).filter(isValidElement);
  const span = responsive ? getResponsiveSpan(columns) : { span: 24 / columns };

  return (
    <Row gutter={gutter} style={gridStyles.container}>
      {childArray.map((child, index) => (
        <Col key={index} {...span}>
          {child}
        </Col>
      ))}
    </Row>
  );
};

export default FormFieldGrid;
